// EditSequence — modal-embedded form for updating a Process (Sequence) row.
// Refactored 2026-05-05 (Phase 3.2, Class P) onto ModalFormHeader.

import React, { useEffect, useState } from "react";
import CTextField from "../CTextField/CTextField";
import {
  Button, Select, MenuItem, FormControl, Stack, Box,
} from "@mui/material";
import { AccountTreeOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../utils/Toast";
import ApiCall from "../../utils/apicall";
import { updateSequence } from "../../feature/sequenceSlice";
import { ModalFormHeader, FieldLabel } from "../PaperForm";

const EditSequence = (props) => {
  const dispatch = useDispatch();
  const [SequenceName, setSequenceName] = useState({
    sequence_name: props.data.sequence_name,
  });
  const [job, setjob] = useState([]);
  const [updatejob, setupdatejob] = useState(props ? props.data.jobid : "");

  useEffect(() => {
    const getjob = async () => {
      const res = await ApiCall.get("/job");
      setjob(res.data.data.jobs);
    };
    getjob();
  }, []);

  const handleSubmit = () => {
    if (!updatejob) { showErrorToast("Please select a job"); return; }
    if (!SequenceName) { showErrorToast("Please enter a Process name"); return; }
    const sequenceData = {
      sequence_name: SequenceName.sequence_name,
      job_id: updatejob,
      id: props.data.id,
    };
    dispatch(updateSequence(sequenceData)).then((res) => {
      if (res.type === "updateSequence/Sequence/fulfilled") {
        const { message } = res.payload;
        showSuccessToast(message);
        props.setOpen(false);
      }
      if (res.type === "updateSequence/Sequence/rejected") {
        showErrorToast("Process not updated! Something went wrong.");
      }
    });
  };

  const handleJobSelection = (event) => {
    setupdatejob(event.target.value);
  };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Process"
        title="Edit Process"
        icon={AccountTreeOutlined}
      />
      <Stack spacing={2}>
        <CTextField
          margin="0px"
          onChange={(event) => setSequenceName(event.target.value)}
          name="sequence_name"
          label="Process name"
          required
          defaultValue={SequenceName.sequence_name}
        />
        <Box>
          <FieldLabel required>Job</FieldLabel>
          <FormControl fullWidth size="small">
            <Select
              value={updatejob}
              onChange={handleJobSelection}
              displayEmpty
              variant="outlined"
              sx={{ textAlign: "left" }}
            >
              <MenuItem value=""><em>Select a job…</em></MenuItem>
              {job.map((dataItem) => (
                <MenuItem key={dataItem.id} value={dataItem.id}>{dataItem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "100%",
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          {props.isLoading ? "Loading…" : "Save changes"}
        </Button>
      </Stack>
    </Box>
  );
};

export default EditSequence;
